import { Button } from 'components/ui/button';
import { Card } from 'components/ui/card';
import { openMailto } from 'lib/mailto';
import React from 'react';

function SignUpPage () {
  const handleStartTrial = () => {
    openMailto('sales@oilytics.co', 'HiLo Trial Access', 'Hello! I\'m interested in a 14 day trial');
  };

  return (
    <div className="min-h-screen bg-muted/40 p-8">
      <div className="mx-auto w-full max-w-4xl">
        <Card className="mt-8 flex flex-col items-center p-8 text-center">
          <h3 className="mb-4 text-3xl font-semibold text-foreground">
            Start a trial for full access
          </h3>

          <h5 className="mb-8 max-w-[600px] text-base text-muted-foreground">
            Contact us to start a 2 week trial with full access to daily market reports, pricing dashboards, fundamentals, and more
          </h5>

          <Button
            size="lg"
            onClick={handleStartTrial}
          >
            Start trial
          </Button>
        </Card>
      </div>
    </div>
  );
}

export default SignUpPage;
